export default {
  badge: 'În configurare',
  title: 'Finalizați configurarea restaurantului',
  description: 'Mai sunt câțiva pași înainte ca restaurantul dvs. să fie live.',
  count: '{{done}} din {{total}} pași finalizați',
  cta: 'Continuați configurarea',
  done: {
    badge: 'Totul este pregătit',
    title: 'Totul este pregătit',
    description: '{{partner}} va activa restaurantul dvs.',
    fallback_partner: 'Furnizorul dvs.',
  },
};
